import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { EditIcon, DeleteIcon } from '../../config/svg/CommonSvg';
import NoDataFound from '../Common/NoDataFound';
import { RoadmapRow, STATUS_PILL_SLUG } from './mockData';

interface ComingNextTableProps {
	rows: RoadmapRow[];
	loading?: boolean;
	onEdit: (row: RoadmapRow) => void;
	onDelete: (row: RoadmapRow) => void;
}

export const ComingNextTable: React.FC<ComingNextTableProps> = ({ rows, loading, onEdit, onDelete }) => {
	const { t } = useTranslation();

	return (
		<TableContainer className='whats-new-roadmap-table'>
			<Table stickyHeader aria-label={t('comingNextLabel')}>
				<TableHead>
					<TableRow>
						<TableCell>{t('itemColumn')}</TableCell>
						<TableCell>{t('statusColumn')}</TableCell>
						<TableCell>{t('targetColumn')}</TableCell>
						<TableCell>{t('impactsColumn')}</TableCell>
						<TableCell align='right' />
					</TableRow>
				</TableHead>
				<TableBody>
					{rows.length === 0 ? (
						<TableRow>
							<TableCell colSpan={5}>
								<NoDataFound loader={!!loading} />
							</TableCell>
						</TableRow>
					) : (
						rows.map((row) => (
							<TableRow key={row.id}>
								<TableCell>
									<Typography variant='body1' className='row-title'>
										{row.title}
									</Typography>
								</TableCell>
								<TableCell>
									<span
										className={`status-pill ${
											STATUS_PILL_SLUG[row.status] ? `status-pill-${STATUS_PILL_SLUG[row.status]}` : ''
										}`}
									>
										{row.status}
									</span>
								</TableCell>
								<TableCell>{row.target}</TableCell>
								<TableCell>
									<span className='impact-tag'>{row.impacts}</span>
								</TableCell>
								<TableCell align='right'>
									<Box className='row-actions'>
										<span className='row-action-btn' id={`edit-roadmap-${row.id}`} onClick={() => onEdit(row)}>
											<EditIcon />
										</span>
										<span className='row-action-btn' id={`delete-roadmap-${row.id}`} onClick={() => onDelete(row)}>
											<DeleteIcon />
										</span>
									</Box>
								</TableCell>
							</TableRow>
						))
					)}
				</TableBody>
			</Table>
		</TableContainer>
	);
};
